<template>
  <div
    class="flex min-w-0 flex-col gap-0.5"
    data-testid="ds-attendance-sla-line"
    :data-container-id="container.id"
  >
    <ModuleViewSlaChip :sla="container.sla ?? null" :now-ms="nowMs" />
    <span class="truncate text-[11px] text-neutral50" data-testid="ds-attendance-sla-line-text">{{
      text
    }}</span>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import ModuleViewSlaChip from '@/components/designSystem/QueueViews/ModuleViewSlaChip.vue'
import type { DSAttendanceContainer } from '@/types/ds-attendance.types'

import { containerSlaLineText } from '../../utils/queue-sla-line'

/** Chip + "Prazo de envio/auditoria · data · janela" (CA2). Um relógio por tela: `nowMs` por prop. */
const props = defineProps<{ container: DSAttendanceContainer; nowMs: number | null }>()

const text = computed(() => containerSlaLineText(props.container))
</script>
